
import { computed, defineComponent } from 'vue'
import SmallHint from '@/components/SmallHint.vue'
import { useBillingStore } from '../../../../store/stores/billing'
import { tariffsFeatures } from '../../billing.consts'
import useRouter from '@/hooks/useRouter'
import { useTariffTrialRestrictions, isTrialAllowedTariff } from '@/hooks/useTariffTrialRestrictions'
export default defineComponent({
    props: { checked: { type: Boolean, default: false }, selectedTariff: { type: String } },
    components: { SmallHint },
    setup(props, { emit }) {
        const billingStore = useBillingStore()
        const { isTrialRestricted } = useTariffTrialRestrictions()
        const tariffOrder: Record<string, number> = {
            tariff1: 1,
            tariff2: 2,
            tariff3: 3,
        }
        const getTariffFeatureId = (tariff: { id: string; baseTariffId?: string | null }) => {
            return tariff.baseTariffId ?? tariff.id
        }
        const getFeatureValue = (
            item: { value?: Record<string, string>; valueFromExtra?: string },
            tariff: { id: string; baseTariffId?: string | null; extra?: Record<string, unknown> | null }
        ) => {
            if (item.valueFromExtra) {
                const extraValue = tariff.extra?.[item.valueFromExtra]
                if (extraValue !== undefined && extraValue !== null && extraValue !== '') {
                    return String(extraValue)
                }
            }

            return item.value?.[getTariffFeatureId(tariff)] ?? ''
        }
        const sortedTariffs = computed(() => {
            const sorted = [...(billingStore.tariffs || [])].sort((a, b) => {
                const left = tariffOrder[getTariffFeatureId(a)] ?? Number.MAX_SAFE_INTEGER
                const right = tariffOrder[getTariffFeatureId(b)] ?? Number.MAX_SAFE_INTEGER
                return left - right
            })
            // На пробном тарифе оставляем только колонки доступных тарифов (Умный бот и tariff3), кроме суперпользователя.
            return isTrialRestricted.value ? sorted.filter(isTrialAllowedTariff) : sorted
        })
        const { route } = useRouter()
        const isRowHighlightEnabled = computed(() => {
            const highlighted = route.value.query.highlighted
            return highlighted === 'true' || highlighted === '1'
        })
        const secondTariffId = computed(() => 'tariff2')
        const tableData = [
            {
                integrationId: 1,
                integrationName: 'Название модуля 1',
                includes: {
                    tariff1: true,
                    tariff2: true,
                    tariff3: true,
                },
            },
            {
                integrationId: 2,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: false,
                    tariff2: true,
                    tariff3: true,
                },
            },
            {
                integrationId: 3,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: true,
                    tariff2: false,
                    tariff3: true,
                },
            },
            {
                integrationId: 4,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: true,
                    tariff2: true,
                    tariff3: false,
                },
            },
            {
                integrationId: 5,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: false,
                    tariff2: true,
                    tariff3: true,
                },
            },
            {
                integrationId: 6,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: false,
                    tariff2: true,
                    tariff3: true,
                },
            },
            {
                integrationId: 7,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: true,
                    tariff2: false,
                    tariff3: true,
                },
            },
            {
                integrationId: 8,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: true,
                    tariff2: true,
                    tariff3: true,
                },
            },
            {
                integrationId: 9,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: true,
                    tariff2: true,
                    tariff3: true,
                },
            },
            {
                integrationId: 10,
                integrationName: 'Название модуля',
                includes: {
                    tariff1: true,
                    tariff2: false,
                    tariff3: true,
                },
            },
        ]
        const getIntegrationIcon = (item: any, tariffId: string) => {
            return item.inTariffs.includes(tariffId) ? 'mdi-check-circle' : 'mdi-minus-circle'
        }
        const getIntegrationIconColor = (item: any, tariffId: string) => {
            return item.inTariffs.includes(tariffId) ? 'mainNew' : undefined
        }
        const shouldHighlightValue = (item: any, tariffId: string) => {
            return isRowHighlightEnabled.value && item.highlighted && tariffId === secondTariffId.value
        }
        return {
            tableData,
            getIntegrationIcon,
            getIntegrationIconColor,
            getTariffFeatureId,
            getFeatureValue,
            billingStore,
            sortedTariffs,
            tariffsFeatures,
            shouldHighlightValue,
        }
    },
})
